import React, { useEffect, useState } from "react";
import {
  OrderResponse,
  getOrderByID,
  patchOrderByID,
} from "../../../../api/order.api";

interface ModalProps {
  deleteID: number;
  isOpen: boolean;
  onClose: () => void;
  action?: () => void;
}

const DeleteMenu: React.FC<ModalProps> = ({
  action,
  isOpen,
  onClose,
  deleteID,
}) => {
  const handleCancleOrder = async () => {
    try {
      await patchOrderByID(deleteID, {
        status: "cancel",
      });
      onClose();
      // @ts-ignore
      action();
    } catch (error) {
      console.error(error);
    }
  };

  const [statusOrderItems, setStatusOrderItems] = useState<OrderResponse>();

  const fetchStatusOrdered = async () => {
    try {
      const statusOrderedUser: OrderResponse = await getOrderByID(deleteID);
      setStatusOrderItems(statusOrderedUser);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchStatusOrdered();
    // const interval = setInterval(() => {
    //   fetchStatusOrdered();
    // }, 5000);
    // return () => {
    //   clearInterval(interval); // Clean up the interval when the component unmounts
    // };
    // Mount-only fetch for the order being cancelled.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isOpen) return null;
  return (
    <>
      <div className="z-[999] h-screen w-full fixed left-0 top-0 bg-black bg-opacity-25 font-nunito">
        <div className="relative  w-full h-full flex flex-col justify-center items-center">
          <div className="mx-[20px] w-10/12 border-0 rounded-lg shadow-lg relative flex flex-col  h-fit bg-white outline-none">
            <div className="flex items-center justify-between mx-16 mt-16">
              <div className="font-semibold text-14 text-center">
                You want to cancel {statusOrderItems?.menu.name}?
              </div>
              <button className="flex justify-start" onClick={onClose}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.3 0.709971C12.91 0.319971 12.28 0.319971 11.89 0.709971L6.99997 5.58997L2.10997 0.699971C1.71997 0.309971 1.08997 0.309971 0.699971 0.699971C0.309971 1.08997 0.309971 1.71997 0.699971 2.10997L5.58997 6.99997L0.699971 11.89C0.309971 12.28 0.309971 12.91 0.699971 13.3C1.08997 13.69 1.71997 13.69 2.10997 13.3L6.99997 8.40997L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L8.40997 6.99997L13.3 2.10997C13.68 1.72997 13.68 1.08997 13.3 0.709971Z"
                    fill="#292929"
                  />
                </svg>
              </button>
            </div>

            {/*body*/}
            <div className="relative mx-16 mb-16  z-[999px]">
              <p className="text-14 text-secondary-S600 pb-16 pt-[18.5px] leading-relaxed">
                Click confirm to cancel
              </p>
              <div className="flex justify-between gap-4 relative">
                <button
                  className="w-full h-32 text-secondary-S600 font-semibold rounded-lg items-center bg-netural-N40 hover:bg-netural-N50"
                  onClick={onClose}
                >
                  Close
                </button>
                <button
                  className="w-full h-32 font-semibold  text-white rounded-lg items-center bg-primary-P500 hover:bg-primary-P300"
                  onClick={handleCancleOrder}
                >
                  Confirm
                </button>
              </div>
            </div>
            {/*footer*/}
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteMenu;
